import { render, staticRenderFns } from "./AddObjectItem.vue?vue&type=template&id=195cfbbc&"
import script from "./AddObjectItem.vue?vue&type=script&lang=js&"
export * from "./AddObjectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports